import { ServiceMode } from 'generated/graphql-gateway';
import { getName } from 'utils/attributes';

const emptyNameParts = {
  firstName: '',
  lastName: '',
};

const normalizeText = (value?: string | null) => value?.trim() || '';

export const getFirstNameFromUserName = (userFullName?: string | null) => {
  const normalizedUserFullName = normalizeText(userFullName);

  if (!normalizedUserFullName) {
    return null;
  }

  const { firstName } = getName({ name: normalizedUserFullName }, emptyNameParts);
  return normalizeText(firstName) || null;
};

export const getPriceOrderCustomerName = ({
  serviceMode,
  userFullName,
  vehicleDescription,
  isFastLaneEnabled,
}: {
  serviceMode?: ServiceMode | null;
  userFullName?: string | null;
  vehicleDescription?: string | null;
  isFastLaneEnabled?: boolean;
}) => {
  const normalizedUserFullName = normalizeText(userFullName);
  const normalizedVehicleDescription = normalizeText(vehicleDescription);

  if (isFastLaneEnabled && serviceMode === ServiceMode.TAKEOUT) {
    return normalizedUserFullName ? `FL-${normalizedUserFullName}` : null;
  }

  if (normalizedVehicleDescription && serviceMode === ServiceMode.MOBILE_ORDER_DRIVE_THRU) {
    return normalizedVehicleDescription;
  }

  return getFirstNameFromUserName(normalizedUserFullName);
};
